import React from 'react'
import ReactDOM from 'react-dom/client'
import { HashRouter, Route, Routes } from 'react-router-dom'
import { initializeIcons } from '@fluentui/react'

import Chat from './pages/chat/Chat'
import Layout from './pages/layout/Layout'
import { AppStateProvider } from './state/AppProvider'

import './index.css'

initializeIcons()

export default function App() {
  return (
    <AppStateProvider>
      <HashRouter>
        <Routes>
          {/* <Route path="/" element={<Layout />}> */}
          <Route index element={<Chat />} />
          {/* </Route> */}
        </Routes>
      </HashRouter>
    </AppStateProvider>
  )
}

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
)
